import { SubText } from '@procurify/ui'
import { nanoid } from 'nanoid'

export interface IBudgetCategoryCardAttributesRowProps {
  name: string
  attributes: string[]
}

export const BudgetCategoryCardAttributesRow = ({
  name,
  attributes,
}: IBudgetCategoryCardAttributesRowProps) => {
  const id = nanoid()

  return (
    <tbody>
      <tr>
        <th>
          <SubText bold autoMargin={false} color='darkGrey' id={id}>
            {name}
          </SubText>
        </th>
        <td aria-labelledby={id}>
          {attributes.map((attribute) => {
            return (
              <SubText bold key={attribute} autoMargin={false}>
                {attribute}
              </SubText>
            )
          })}
        </td>
      </tr>
    </tbody>
  )
}

BudgetCategoryCardAttributesRow.displayName = 'BudgetCategoryCardAttributesRow'
